import React from 'react';
import PropTypes from 'prop-types';

import { FeatureTag } from "./FeatureTag";

import "./FeatureTags.scss";

export const FeatureTags = ({tags}) => (
    <ul className="feature-tags">    
      {tags.map(tag => (
        <FeatureTag key={tag} tag={tag} />
      ))}
    </ul>
);

FeatureTags.propTypes = {
  tags: PropTypes.array.isRequired,
}
